var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 4.5C21.0326 4.5 15.3097 6.87053 11.0901 11.0901C6.87053 15.3097 4.5 21.0326 4.5 27C4.5 32.9674 6.87053 38.6903 11.0901 42.9099C15.3097 47.1295 21.0326 49.5 27 49.5C32.9674 49.5 38.6903 47.1295 42.9099 42.9099C47.1295 38.6903 49.5 32.9674 49.5 27C49.5 21.0326 47.1295 15.3097 42.9099 11.0901C38.6903 6.87053 32.9674 4.5 27 4.5Z",
    fill: "#0288D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7499 21.375H20.2499V38.25H15.7499V21.375ZM17.9864 19.125H17.9617C16.6184 19.125 15.7499 18.1237 15.7499 16.8739C15.7499 15.597 16.6454 14.625 18.0123 14.625C19.3814 14.625 20.2241 15.597 20.2499 16.8739C20.2499 18.1237 19.3814 19.125 17.9864 19.125ZM39.3749 27.5625C39.3749 24.1447 36.6052 21.375 33.1874 21.375C31.0927 21.375 29.2443 22.419 28.1249 24.012V21.375H23.6249V38.25H28.1249V29.25C28.1249 27.3859 29.6358 25.875 31.4999 25.875C33.3641 25.875 34.8749 27.3859 34.8749 29.25V38.25H39.3749C39.3749 38.25 39.3749 28.0361 39.3749 27.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1ccc66e57159650614145ee954ddf1e7.svg";
export { ForwardRef as ReactComponent };